export enum FilesBucketNames {
  PUBLIC = 'public',
  TICKET = 'ticket'
}
